import axios from 'axios';
import ApiService from '../../data/ApiService';

const api = new ApiService();

function getHeader(token){
    return {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
}

async function getClient(page, keycloak) {
    await api.refreshToken(keycloak)

    return axios.create({ 
                baseURL: process.env.REACT_APP_BASEURL + page, 
                timeout: 31000, 
                headers: getHeader(keycloak.token) });
}

export default {
    getAttributes: async function(keycloak) {
        try {
            const client = await getClient('attribute', keycloak)
            const response = 
                await client.get();

            return response.data;
        }catch (error) {
            return [
                {
                    "attributeId": 1,
                    "attributename": "Batchname",
                },{
                    "attributeId": 2,
                    "attributename": "Code",
                },{
                    "attributeId": 3,
                    "attributename": "GS1_01",
                },{
                    "attributeId": 4,
                    "attributename": "GS1_Desc",
                },{
                    "attributeId": 5,
                    "attributename": "Lot",
                }
            ]
            /* throw error; */
        }
    },

    getPages: async function(keycloak) {
        try {
            const client = await getClient('page/react', keycloak)
            const response = 
                await client.get();

            return response.data;
        }catch (error) {
            throw error;
        }
    },

    createPage: async function(keycloak, page) {
        try {
            await api.refreshToken(keycloak)
            const response = await axios.post(process.env.REACT_APP_BASEURL + 'page', page, {headers: getHeader(keycloak.token)})
            return response.data;
        }catch (error) {
            throw error;
        }
    },

    editPage: async function(keycloak, pageId, page) {
        try {
            await api.refreshToken(keycloak)
            const response = await axios.put(process.env.REACT_APP_BASEURL + 'page/' + pageId, page, {headers: getHeader(keycloak.token)})
            return response.data;
        }catch (error) {
            throw error;
        }
    },

    deletePage: async function(keycloak, pageId) {
        try {
            await api.refreshToken(keycloak)
            const response = await axios.delete(process.env.REACT_APP_BASEURL + 'page/' + pageId, {headers: getHeader(keycloak.token)})
            return response.data;
        }catch (error) {
            throw error;
        }
    },

    getLanguages: function() {
        return [
/*             { id: "ar", label: "Arabic" },
            { id: "zh", label: "Chinese" },
            { id: "cs", label: "Czech" },
            { id: "nl", label: "Dutch" },
 */            
            { id: "fr", label: "French" },
            { id: "de", label: "German" },
            { id: "it", label: "Italian" },
/*             { id: "ja", label: "Japanese" },
            { id: "ko", label: "Korean" },
            { id: "tw", label: "Mandarin" },
            { id: "mx", label: "Mexican" },
            { id: "pl", label: "Polish" },
            { id: "pt", label: "Portugues" },
            { id: "ru", label: "Russian" }, */
            { id: "es", label: "Spanish" },
/*             { id: "tr", label: "Turkish" },
            { id: "vn", label: "Vietnamita" } */
        ]
    }
}
